export const PERIOD_OPTIONS = [
  { value: "7d", label: { key: "leaderboard-period-7d", fallback: "7 days" } },
  { value: "28d", label: { key: "leaderboard-period-28d", fallback: "28 days" } },
  { value: "30d", label: { key: "leaderboard-period-30d", fallback: "30 days" } },
  { value: "90d", label: { key: "leaderboard-period-90d", fallback: "90 days" } },
  { value: "all", label: { key: "leaderboard-period-all", fallback: "All time" } }
] as const

export const DEFAULT_PERIOD = PERIOD_OPTIONS[1].value

export const SCOPE_OPTIONS = [
  { value: "all", label: { key: "leaderboard-scope-all", fallback: "All" } },
  { value: "members", label: { key: "leaderboard-scope-members", fallback: "Members" } },
  { value: "administrators", label: { key: "leaderboard-scope-administrators", fallback: "Administrators" } }
] as const

export const DEFAULT_SCOPE = SCOPE_OPTIONS[0].value
